import { Component, Input } from '@angular/core'
import { ImageComponent } from '@shared/components/common/image/image.component'
import { TranslatePipe } from '@ngx-translate/core'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'

@UseLocales({ ru, en })
@Component({
	selector: 'app-empty-table',
	templateUrl: './empty-table.component.html',
	styleUrl: './empty-table.component.scss',
	imports: [ImageComponent, TranslatePipe],
})
export class EmptyTableComponent {
	@Input() textPath: string = ''
}
